import { ENUMS } from '@rapyd/use-hcp-preview';
import { MANDATORY_CARD_FIELDS } from 'consts/card';
import { HOSTED_PAGE_TYPES, SUCCESS_CODE, ACT_CODE, ERROR_CODE } from 'consts/global';
import { GA_CATEGORIES } from 'consts/analytics/ga';

export const RAPYD_LOGO = 'https://dashboard.rapyd.net/images/rapyd-logo-black.svg';
export const DEMO_IFRAME_ID = 'demo-page';

export const TEXTS_BY_HOSTED_PAGE = {
  [HOSTED_PAGE_TYPES.checkout]: {
    titleText: 'Explore Checkout',
    urlText: 'checkout.rapyd.net'
  }
};

export enum DemoViews {
  Desktop = 'desktop',
  Mobile = 'mobile'
}

export enum PreviewParamKeys {
  ctaText = 'ctaText',
  buttonColor = 'buttonColor',
  pageType = 'pageType',
  view = 'view',
  categories = 'categories',
  env = 'env',
  checkoutPage = 'checkoutPage',
  language = 'language',
  previewApplePay = 'previewApplePay',
  previewGooglePay = 'previewGooglePay',
  isDemo = 'isDemo',
  alias = 'alias',
  btnColor = 'btnColor',
  logo = 'logo',
  reusablePage = 'reusablePage'
}

export enum CheckoutPagePreviewParamKeys {
  cart_items = 'cart_items',
  payment_fx_metadata = 'payment_fx_metadata',
  calculated_payment_fees = 'calculated_payment_fees'
}

export enum Colors {
  Purple = '#7437F5',
  LightBlue = '#C6D8FF',
  DarkCyan = '#009DA0',
  Black = '#000000'
}

export const CHECKOUT_DEMO_DEFAULT_COLORS = [
  Colors.Purple,
  Colors.LightBlue,
  Colors.DarkCyan,
  Colors.Black
];

export const CHECKOUT_CATEGORIES_LIST = [
  ENUMS.CHECKOUT_CATEGORIES.Bank,
  ENUMS.CHECKOUT_CATEGORIES.Card,
  ENUMS.CHECKOUT_CATEGORIES.Cash,
  ENUMS.CHECKOUT_CATEGORIES.Ewallet
];

export const CHECKOUT_DEMO_INITIAL_AMOUNT = 49;

export const CHECKOUT_DEMO_TRANSACTION_FEE = 1.47;

export const CHECKOUT_DEMO_FX_RATE = 0.88;

export const CASE_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  AUTH: 'auth'
};

export const cardDetails = {
  [CASE_TYPES.SUCCESS]: {
    [MANDATORY_CARD_FIELDS.number]: '4111111111113321',
    [MANDATORY_CARD_FIELDS.cvv]: '123',
    [MANDATORY_CARD_FIELDS.expiration]: '12/30',
    [MANDATORY_CARD_FIELDS.cardholder]: 'John Gibson'
  },
  [CASE_TYPES.ERROR]: {
    [MANDATORY_CARD_FIELDS.number]: '4111111111112345',
    [MANDATORY_CARD_FIELDS.cvv]: '456',
    [MANDATORY_CARD_FIELDS.expiration]: '06/30',
    [MANDATORY_CARD_FIELDS.cardholder]: 'John Gibson'
  },
  [CASE_TYPES.AUTH]: {
    [MANDATORY_CARD_FIELDS.number]: '4111111111111245',
    [MANDATORY_CARD_FIELDS.cvv]: '789',
    [MANDATORY_CARD_FIELDS.expiration]: '09/30',
    [MANDATORY_CARD_FIELDS.cardholder]: 'John Gibson'
  }
};

export const ANIMATION_DURATION = 200;

export const DEFAULT_MENU_MARGIN = '3.5rem';

export const BACK_BUTTON_TOOLTIP_TEXT =
  'Configure the cancel URL to redirect the customer back to your website';

export const MOBILE_MODE_SCREEN_DIMENSIONS = {
  small: {
    width: 32,
    height: 63
  },
  large: {
    width: 40,
    height: 90
  }
};

export const GA_EVENT_BY_CARD_PAYMENT_STATUS = {
  [SUCCESS_CODE]: GA_CATEGORIES.SUBMIT_CARD_SUCCESS,
  [ERROR_CODE]: GA_CATEGORIES.SUBMIT_CARD_FALIED,
  [ACT_CODE]: GA_CATEGORIES.SUBMIT_CARD_AUTH
};
